import { Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { IMaterialSplitDialogProps } from '../../interfaces';



export const MaterialSplitDialog: React.SFC<IMaterialSplitDialogProps> = ({
    quantity,
    onSubmitMaterial,
    ...props
}: IMaterialSplitDialogProps) => {


    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();
        e.stopPropagation();

        if (e.currentTarget.checkValidity()) {


            onSubmitMaterial(splitQty);


            setOpen(false);
        } else {

        }

    }

    const onCancel = () => {

        setOpen(false);
    }

    const [open, setOpen] = useState(false);
    const [splitQty, setSplitQty] = useState(1);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);


    return (
        <span>
            <Button variant="outlined" color="warning" onClick={() => setOpen(true)}>
                Split
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
            >
                <form
                    onSubmit={(e) => onSubmit(e)}
                    onInvalid={() => setErrorMessage("please check that all required fields have been populated")}
                >
                    <DialogTitle>
                        Split Material
                    </DialogTitle>
                    <DialogContent>
                        <Typography>The current material will be cloned with the new quantity assigned to it.</Typography>
                        <Grid container sx={{ mt: 3 }}>
                            <Grid item={true} xs={10} sx={{ p: 0.5 }}>
                                <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    label="New Material Quantity"
                                    type="number"
                                    inputProps={{ min: 1, max: (quantity - 1) }}
                                    value={splitQty}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setSplitQty(parseInt(e.currentTarget.value))}
                                    helperText={<><strong>{quantity - splitQty}</strong> remaining for the current material</>}
                                />
                            </Grid>
                        </Grid>

                        {errorMessage &&
                            <DialogContentText color="error">
                                {errorMessage}
                            </DialogContentText>
                        }

                    </DialogContent>
                    <DialogActions>

                        <Button onClick={onCancel} color="warning">Cancel</Button>

                        <Button type="submit">Split</Button>

                    </DialogActions>

                </form>
            </Dialog>
        </span>
    );
}